import { getStatusTextAndColorCode } from '@/common-utils'
import constants from '@/constants'

const { ORDER_PRODUCT_SHIPMENT_STATUS } = constants

// KP-4363: a confirmed line of a partially confirmed order ships only once its
// catalogue product is ready to ship (the backend's confirmedShippableStatus),
// like a readyToShip line on a confirmed order. Until then it is still live.
export const isConfirmedLineNotReady = product => product?.status === ORDER_PRODUCT_SHIPMENT_STATUS.CONFIRMED.LABEL
  && product?.confirmedShippableStatus !== ORDER_PRODUCT_SHIPMENT_STATUS.READY_TO_SHIP.LABEL

// A confirmed line reads "Confirmed · Ready to Ship" or, while its product is
// still live, "Confirmed · Processing". Every other line reads as
// getStatusTextAndColorCode.
export const getLineStatusText = (product, order = null) => {
  if (isConfirmedLineNotReady(product)) return ORDER_PRODUCT_SHIPMENT_STATUS.CONFIRMED_PROCESSING.TEXT
  return getStatusTextAndColorCode(product?.status, order).text
}

// Whether the line gets the ship checkbox.
export const isLineShipSelectable = (product, order = null) => getStatusTextAndColorCode(product?.status, order).isEnabled
  && !isConfirmedLineNotReady(product)
